import * as React from "react";
import { useTranslation } from "react-i18next";
import { ErrorCodes } from "../@types/ErrorCodes";
import { ParseKeys } from "i18next";
import { IconMailExclamation } from "@tabler/icons-react";

interface ErrorPageProps {
  code: ErrorPageErrorCode;
}
export function ErrorPage(props: ErrorPageProps) {
  const { t } = useTranslation();
  const errorMessage = t(errorMessages[props.code]);

  let message = errorMessage;
  let description = "";

  const sentenceRegex = /(?<=[.!?])\s+/;

  if (props.code === ErrorCodes.E0101 || props.code === ErrorCodes.E0102) {
    const [msg, ...desc] = errorMessage.split(sentenceRegex);
    message = msg;
    description = desc.join(" ");

    const descriptionLines = description.split(sentenceRegex);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <IconMailExclamation stroke={1} size={150} color="#007EA3" />
        <h3>{message}</h3>
        {descriptionLines.length > 0 && (
          <div style={{ fontSize: "smaller" }}>
            {descriptionLines.map((line, index) => (
              <p style={{ marginTop: "-15px" }} key={index}>
                {line.trim()}
              </p>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <p style={{ fontSize: "smaller" }}>{t(errorMessages[props.code])}</p>
    </div>
  );
}

export type ErrorPageErrorCode =
  ErrorCodes.E0002 | ErrorCodes.E0101 | ErrorCodes.E0102;

export const errorMessages: Record<ErrorPageErrorCode, ParseKeys> = {
  E0002: "errors.E0002",
  E0101: "errors.E0101",
  E0102: "errors.E0102",
};
